import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const code = err.response?.data?.code;

    // Token expired/invalid, or account deactivated -> back to login
    if (status === 401) {
      localStorage.removeItem('hp_token');
      localStorage.removeItem('hp_admin');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    // Still on a temporary password -> force the set-password screen
    if (status === 403 && code === 'PASSWORD_CHANGE_REQUIRED') {
      if (window.location.pathname !== '/set-password') {
        window.location.href = '/set-password';
      }
    }

    return Promise.reject(err);
  }
);

export default api;
